class TotalSavings extends HTMLElement {
  constructor() {
    super();
    this.setSavings();
  }

  get originalTotalPrice() {
    if (!this.hasAttribute("data-original-total-price")) {
      return 0;
    }

    return Number(this.getAttribute("data-original-total-price"));
  }

  get lineItem() {
    if (!this.hasAttribute("data-line-item")) {
      return null;
    }

    return JSON.parse(this.getAttribute("data-line-item"));
  }

  get savedAmount() {
    if (!this.hasAttribute("data-saved-amount")) {
      return 0;
    }

    return Number(this.getAttribute("data-saved-amount"));
  }

  calculateBundleSavings() {
    if (!this.lineItem) {
      return 0;
    }

    const savings = this.lineItem.properties["Bundle-Rabatt"];
    const savingsAmount = Math.round(
      Number(savings.match(/CHF\s*(\d+[.,]\d+)/)[1].replace(",", ".")) * 100
    );

    return savingsAmount;
  }

  formatMoney(amount) {
    return `SFr. ${amount.toFixed(2)}`;
  }

  setSavings() {
    const bundleSavings = this.calculateBundleSavings();
    const totalSavings = bundleSavings + this.savedAmount;
    const totalPrice = this.originalTotalPrice + bundleSavings;

    if (totalSavings <= 0) {
      return;
    }

    const percentage = Math.round((totalSavings / totalPrice) * 100);

    const style = document.createElement("style");
    style.innerHTML = `
      .percentage {
        color: var(--White-100, #FFF);
        text-align: center;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        letter-spacing: 0.01px;
        border-radius: 2px;
        background: var(--Cherry-Rot, #C02942);
        padding: 2px 5px;
        width: fit-content;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .amount {
        color: #C02942;
        
      }
    `;

    const savingsElement = document.createElement("div");
    savingsElement.classList.add(
      "tw-flex",
      "tw-items-center",
      "tw-justify-between"
    );
    savingsElement.innerHTML = `   
          <div class="percentage">Du sparst (${percentage}%)</div>
          <div class="text-bas amount">${this.formatMoney(
            totalSavings / 100
          )}</div>
        `;
    this.appendChild(style);
    this.appendChild(savingsElement);
  }
}

customElements.define("total-savings", TotalSavings);
